import { SET_APPLICANT_TAGS } from '../actions/actions';
import produce from 'immer';

const INITIAL_STATE = {
  tags: []
};

export default function applicantTagsReducer(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_APPLICANT_TAGS: {
        draft.tags = action.payload;
        break;
      }

      default:
        return state;
    }
  });
}
